export default {
  dialer: 'Dial Pad',
  allCalls: 'All Calls',
} as const;
